import { Box, Button, TextField } from '@mui/material'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ShowDialogProps } from 'src/show-dialog'
import { GenericDialogLayout } from '../GenericDialogLayout'

interface IDraftCaptionDialog extends ShowDialogProps<string> {
  initialCaption?: string
}

const DraftCaptionDialog: React.FC<IDraftCaptionDialog> = ({ pop, initialCaption }) => {
  const { t } = useTranslation(['form-schema-report', 'common'])
  const [caption, setCaption] = useState(initialCaption ?? '')

  return (
    <GenericDialogLayout
      title={t('save-as-draft', { ns: 'form-schema-report' })}
      pop={() => pop()}
      actions={[
        <Button key="save" variant="contained" onClick={() => pop(caption)}>
          {t('save', { ns: 'common' })}
        </Button>,
      ]}
    >
      <Box padding={2}>
        <TextField
          fullWidth
          label={t('draft-caption', { ns: 'form-schema-report' })}
          placeholder={t('draft-caption-placeholder', { ns: 'form-schema-report' })}
          value={caption}
          onChange={e => setCaption(e.target.value)}
          autoFocus
        />
      </Box>
    </GenericDialogLayout>
  )
}

export default DraftCaptionDialog
